import { ExtrudeGeometry, Shape } from "three";

export class BeveledUvBufferGeometry extends ExtrudeGeometry {
  constructor(
    width: number,
    height: number,
    depth: number,
    radius0: number,
    smoothness: number,
    UVGenerator: any = undefined,
  ) {
    const shape = new Shape();
    const eps = 0.00001;
    const radius = radius0 - eps;
    shape.absarc(eps, eps, eps, -Math.PI / 2, -Math.PI, true);
    shape.absarc(eps, height - radius * 2, eps, Math.PI, Math.PI / 2, true);
    shape.absarc(width - radius * 2, height - radius * 2, eps, Math.PI / 2, 0, true);
    shape.absarc(width - radius * 2, eps, eps, 0, -Math.PI / 2, true);

    const options = {
      depth: depth - radius0 * 2,
      bevelEnabled: true,
      bevelSegments: smoothness * 2,
      steps: 1,
      bevelSize: radius,
      bevelThickness: radius0,
      curveSegments: smoothness,
      UVGenerator,
    };

    super(shape, options);

    this.center();
  }
}
